var _rect, _rect2, _path, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15.5,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3643 12.2529V13.7129H68.6123V12.2529H69.3643ZM69.2715 20.2266V21.5352H68.5244V20.2266H69.2715ZM70.0088 18.6494C70.0088 18.4606 69.9697 18.2962 69.8916 18.1562C69.8167 18.013 69.693 17.8844 69.5205 17.7705C69.348 17.6533 69.1169 17.5443 68.8271 17.4434C68.4105 17.2969 68.0459 17.1325 67.7334 16.9502C67.4242 16.7646 67.1833 16.5368 67.0107 16.2666C66.8415 15.9932 66.7568 15.653 66.7568 15.2461C66.7568 14.8457 66.848 14.499 67.0303 14.2061C67.2158 13.9131 67.473 13.6868 67.8018 13.5273C68.1305 13.3678 68.5146 13.2881 68.9541 13.2881C69.2926 13.2881 69.597 13.3385 69.8672 13.4395C70.1406 13.5404 70.3734 13.6885 70.5654 13.8838C70.7575 14.0791 70.904 14.32 71.0049 14.6064C71.109 14.8896 71.1611 15.2152 71.1611 15.583H69.9893C69.9893 15.3747 69.9648 15.1891 69.916 15.0264C69.8704 14.8604 69.8021 14.7204 69.7109 14.6064C69.6198 14.4893 69.5091 14.3997 69.3789 14.3379C69.252 14.276 69.1071 14.2451 68.9443 14.2451C68.7132 14.2451 68.5228 14.2891 68.373 14.377C68.2233 14.4616 68.1126 14.5788 68.041 14.7285C67.9727 14.8783 67.9385 15.0492 67.9385 15.2412C67.9385 15.4268 67.9743 15.5895 68.0459 15.7295C68.1175 15.8695 68.2396 15.9964 68.4121 16.1104C68.5879 16.221 68.8288 16.3333 69.1348 16.4473C69.5547 16.597 69.9176 16.7646 70.2236 16.9502C70.5329 17.1325 70.7705 17.3587 70.9365 17.6289C71.1058 17.8958 71.1904 18.2327 71.1904 18.6396C71.1904 19.0596 71.0928 19.416 70.8975 19.709C70.7054 20.002 70.4352 20.2249 70.0869 20.3779C69.7419 20.5277 69.3398 20.6025 68.8809 20.6025C68.5911 20.6025 68.3031 20.5651 68.0166 20.4902C67.7334 20.4121 67.4762 20.2852 67.2451 20.1094C67.014 19.9336 66.8301 19.7008 66.6934 19.4111C66.5566 19.1182 66.4883 18.7601 66.4883 18.3369H67.6699C67.6699 18.5908 67.7041 18.8024 67.7725 18.9717C67.8408 19.141 67.9336 19.2744 68.0508 19.3721C68.168 19.4697 68.2982 19.5397 68.4414 19.582C68.5879 19.6243 68.7344 19.6455 68.8809 19.6455C69.125 19.6455 69.3301 19.6048 69.4961 19.5234C69.6654 19.4388 69.7923 19.3216 69.877 19.1719C69.9648 19.0189 70.0088 18.8447 70.0088 18.6494Z",
    fill: "#3A3A3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 36,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutRight);
export default __webpack_public_path__ + "static/media/ItemLayoutRight.c04f23f09416e88c6a482fe868b43049.svg";
export { ForwardRef as ReactComponent };